import { useEffect, useRef } from 'react';

// Source: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export default function useInterval(callback, delay, runNow = false) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    let id;
    if (delay !== null) {
      id = setInterval(tick, delay);
    }
    if (runNow) {
      tick();
    }
    if (delay !== null) {
      return () => clearInterval(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay]);
}